import React from "react";
import { Section, SectionTitle, Reveal } from "../components/Section";

const PORTRAIT_COUPLE =
  "https://customer-assets.emergentagent.com/job_bride-entrance/artifacts/hycdnvi6_00550f9defc41dfb4bcd4692100ea359b9f7803a.webp";
const PORTRAIT_CELEBRATION =
  "https://customer-assets.emergentagent.com/job_bride-entrance/artifacts/ell0bjqk_b3ad83826d1fc7036753ebb13465436c349f896d.webp";

const PersonCard = ({ portrait, role, name, parents, objectPosition, delay }) => (
  <Reveal delay={delay} className="text-center">
    <div className="relative w-56 h-72 md:w-64 md:h-80 mx-auto overflow-hidden mb-6"
         style={{ borderRadius: "50% 50% 50% 50% / 60% 60% 40% 40%" }}>
      <div className="absolute inset-0 border border-gold/60 z-10 pointer-events-none"
           style={{ borderRadius: "50% 50% 50% 50% / 60% 60% 40% 40%" }} />
      <img
        src={portrait}
        alt={name}
        className="w-full h-full object-cover"
        style={{ filter: "saturate(0.95)", objectPosition }}
      />
    </div>
    <p className="text-xs tracking-[0.3em] uppercase text-gold mb-2">{role}</p>
    <h3 className="font-serif text-3xl md:text-4xl text-charcoal">{name}</h3>
    <p className="text-sm text-charcoal/70 mt-3 leading-relaxed whitespace-pre-line">{parents}</p>
  </Reveal>
);

export default function Couple() {
  return (
    <Section testId="couple-section" className="bg-ivory">
      <SectionTitle overline="Mempelai" title="The Bride" italic="& Groom" />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 items-start">
        <PersonCard
          delay={0.0}
          portrait={PORTRAIT_CELEBRATION}
          role="The Groom"
          name="Kevin Husada"
          objectPosition="20% 30%"
          parents={"Putra dari\nBpk. Budi Husada\n& Ibu Valery"}
        />
        <PersonCard
          delay={0.2}
          portrait={PORTRAIT_COUPLE}
          role="The Bride"
          name="Angeline Wijaya"
          objectPosition="65% 30%"
          parents={"Putri dari\nBpk. Wendy Wijaya\n& Ibu Pauline"}
        />
      </div>
    </Section>
  );
}
